<script setup lang="ts">
import { findClientByTributaryCode } from '@repositories/landing.repository';
import { validationRut } from '../../../../../helpers/validationRUT';
import { ref } from 'vue';
import storePolicy from '@store/policy';
import { useI18n } from 'vue-i18n'

const { t } = useI18n();
const props = defineProps<{ companySelectedByParams: any, inputsHidden: boolean }>();
const emit = defineEmits(['submitRUT']);
const store = storePolicy();

const fieldsForm1: any = ref([
  {
    key: 'rut',
    title: t('landing.forms.form_rut_cl.rut_del_cliente'),
    type: 'text',
    validations: {
      rules: {
        required: true,
      },
    },
    placeholder: t('landing.forms.form_rut_cl.rut_del_cliente'),
    value: null,
    cols: 12,
    customClass: 'inputLanding text-uppercase',
    hidden: false,
    errors: [],
  },
]);
const handleOnSubmitRUT = async (e: any) => {
  // 19876543-0 42.245.781-K
  const isValidRUT = validationRut(e.items.rut);
  if (!e.isFormValid || !isValidRUT) {
    return (fieldsForm1.value[0].errors = ['RUT es invalido']);
  }
  const rutWithoutSpecialChars = e.items.rut.replace(/[-.]/g, '');
  const { client } = await findClientByTributaryCode(rutWithoutSpecialChars);

  if (client) {
    store.setProp({ key: 'client', value: client });
  }

  if (client) {
    const updatesClientInputs = [
      { key: 'tradeName', value: client.tradeName },
      { key: 'phone1', value: client.phone1 },
	  {
        key: 'companyGPSId',
        value: {
          id: props.companySelectedByParams?.id ?? client.companyGPS.id,
          nombre:
            props.companySelectedByParams?.nombre ??
            client.companyGPS.description,
        },
      },
      { key: 'address', value: client.address },
      { key: 'region', value: { nombre: client.regionProvince } },
      { key: 'comuna', value: { nombre: client.location } },
      { key: 'postCode', value: client.postCode },
    ];
	fieldsForm1.value.find((field: any) => field.key === 'rut').disabled = true;
	return emit('submitRUT', {rfc: e.items.rfc, updatesClientInputs, client});

  }
  emit('submitRUT', { rut: e.items.rut });
};


</script>

<template>
  <Form ref="refTableForm" :inputs="fieldsForm1" @onSubmit="handleOnSubmitRUT">
    <template #buttons>
      <div class="d-flex" v-if="inputsHidden">
        <CButton
          class="p-4 w-100 my-2 px-2"
          background="background-green"
          style="font-size: 1rem"
        >
          <template #content>{{ t('landing.forms.form_rut_cl.comprobar_rut') }}</template>
        </CButton>
      </div>
    </template>
  </Form>
</template>
